export const PROGRAM_ENROLLMENT_CONFIRMED_EVENT = "programEnrollmentConfirmed";
export const PROGRAM_ENROLLMENT_STORAGE_KEY = "programEnrollmentConfirmed";

export type ProgramEnrollmentConfirmedPayload = {
  programSessionId: string;
  at: number;
};

export function notifyProgramEnrollmentConfirmed(programSessionId: string) {
  if (!programSessionId) return;

  const payload: ProgramEnrollmentConfirmedPayload = {
    programSessionId,
    at: Date.now(),
  };

  localStorage.setItem(PROGRAM_ENROLLMENT_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(
    new CustomEvent(PROGRAM_ENROLLMENT_CONFIRMED_EVENT, { detail: payload })
  );

  if (window.opener && !window.opener.closed) {
    window.opener.postMessage(
      { type: PROGRAM_ENROLLMENT_CONFIRMED_EVENT, ...payload },
      window.location.origin
    );
  }
}

export function returnToCheckoutOpener(programSessionId: string) {
  notifyProgramEnrollmentConfirmed(programSessionId);

  if (!window.opener || window.opener.closed) return false;

  try {
    window.opener.focus();
  } catch {
    // ignore focus errors in restrictive browsers
  }

  window.close();
  return true;
}

export function hasCheckoutOpener() {
  return !!window.opener && !window.opener.closed;
}

export function subscribeProgramEnrollmentConfirmed(
  handler: (programSessionId: string) => void
) {
  const onCustom = (event: Event) => {
    const detail = (event as CustomEvent<ProgramEnrollmentConfirmedPayload>).detail;
    if (detail?.programSessionId) handler(detail.programSessionId);
  };

  const onStorage = (event: StorageEvent) => {
    if (event.key !== PROGRAM_ENROLLMENT_STORAGE_KEY || !event.newValue) return;
    try {
      const data = JSON.parse(event.newValue) as ProgramEnrollmentConfirmedPayload;
      if (data.programSessionId) handler(data.programSessionId);
    } catch {
      // ignore malformed payload
    }
  };

  const onMessage = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;
    if (
      event.data?.type === PROGRAM_ENROLLMENT_CONFIRMED_EVENT &&
      event.data.programSessionId
    ) {
      handler(event.data.programSessionId);
    }
  };

  window.addEventListener(PROGRAM_ENROLLMENT_CONFIRMED_EVENT, onCustom);
  window.addEventListener("storage", onStorage);
  window.addEventListener("message", onMessage);

  return () => {
    window.removeEventListener(PROGRAM_ENROLLMENT_CONFIRMED_EVENT, onCustom);
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("message", onMessage);
  };
}
